<template>
  <v-btn
    :disabled="disabled"
    :loading="loading"
    :color="color"
    @click="handleClick"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script>
import { RELEASE_TYPES } from '@/utils/Const';

export default {
  name: 'PublishButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    releaseType: {
      type: String,
      default: RELEASE_TYPES.SCHEDULED
    },
    hasPendingChanges: {
      type: Boolean,
      default: false
    },
    hasReleaseChanges: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    buttonText() {
      if (!this.hasPendingChanges) {
        return this.$t('common.done');
      }
      
      // If we have release-specific changes, show release-specific text
      if (this.hasReleaseChanges) {
        switch (this.releaseType) {
          case RELEASE_TYPES.LISTED:
            return this.$t('admin.productsDatabase.importWizard.steps.release.releaseNow');
          case RELEASE_TYPES.SCHEDULED:
            return this.$t('admin.productsDatabase.importWizard.steps.release.scheduleForRelease');
          case RELEASE_TYPES.UNLISTED:
            return this.$t('admin.productsDatabase.importWizard.steps.release.unlist');
          default:
            return this.$t('admin.productsDatabase.importWizard.publish');
        }
      }
      
      // Otherwise, generic save changes text
      return this.$t('common.saveChanges');
    },
    color() {
      return this.hasPendingChanges ? 'success' : 'primary';
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>